import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import "../assets/css/vrfsystem.css"
const vrfSystems = [
  {
    image: require("../assets/images/outdoor.jpeg"),
    title: "VRF Outdoor Units",
    description: "High-performance outdoor units delivering exceptional energy efficiency and reliable operation for your building's climate control needs.",
    bulletList: [
      "Inverter Technology for precise temperature control and reduced energy consumption",
      "Modular Design allowing for flexible installation and system expansion",
      "Smart Connectivity with BMS systems and remote monitoring capabilities",
      "Compact Footprint maximizing usable roof or ground space"
    ],

  },
  {
    image: require("../assets/images/vrfIndoor.jpg"),
    title: "VRF Indoor Units",
    description: "Versatile indoor units designed to complement any interior while providing optimal comfort and air distribution.",
    bulletList: [
      "Ceiling Cassettes with 360° airflow for even temperature distribution",
      "Wall-Mounted Units featuring sleek, modern designs for visible installations",
      "Ducted Systems for concealed installations with minimal visual impact",
      "Floor-Standing Models for applications without wall or ceiling space"
    ],
  
  },
  {
    image: require("../assets/images/smartController.jpg"),
    title: "Smart Controllers",
    description: "Advanced control systems providing intuitive operation and comprehensive system management capabilities.",
    bulletList: [
      "Wireless Controls accessible via smartphone or tablet for convenient adjustments",
      "Central Management System for monitoring multiple units from a single interface",
      "Energy Monitoring tools to optimize performance and reduce operating costs",
      "Scheduling Features to automate temperature settings based on occupancy patterns"
    ],

  }
];

const VRFSystems = () => {
  return (
    <section className="vrf-systems-section py-5">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title mb-3">High-Performance VRF Systems for Every Space</h2>
        </div>
        
        <Row className="g-4">
          {vrfSystems.map((system, index) => (
            <Col key={index} md={4} className="mb-4">
              <div className="vrf-card h-100 overflow-hidden">
                <div className="card-image-container">
                  <img 
                    src={system.image} 
                    alt={system.title} 
                    className="vrf-image p-3 "
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title">{system.title}</h3>
                  <p className="card-description">{system.description}</p>
                  
                  <div className="features-container">
                    <h5 className="features-title">Key Features</h5>
                    <ul className="features-list">
                      {system.bulletList.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  
                  {/* <div className="benefits-badge">
                    <i className="bi bi-star-fill me-2"></i>
                    {system.benefits}
                  </div> */}
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        <div className="cta-container text-center mt-5">
          <h4 className="cta-title">Ready to upgrade your building's climate system?</h4>
          <p className="cta-text">Our experts will help you design the perfect VRF solution for your needs</p>
          <div className="cta-buttons">
            <a href="/contact" className="btn btn-primary cta-button">
              <i className="bi bi-calendar-check me-2"></i>Schedule a Consultation
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default VRFSystems;